import { array, literal, partial, type Decoder } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const SearchDataTableType = <
	RequestType,
	ColumnField extends string,
	FilterId extends string,
>({
	columnFields,
	filterIds,
	request,
}: {
	columnFields: readonly ColumnField[];
	filterIds: readonly FilterId[];
	request: Decoder<unknown, RequestType>;
}) =>
	partial({
		request,
		columns: partial({
			hidden: iotsUtils.makePartialRecordDecoder(columnFields, literal(true)),
			order: array(iotsUtils.fromList(columnFields)),
		}),
		filters: partial({
			secondary: array(iotsUtils.fromList(filterIds)),
		}),
	});
